export const getCustomerInformation = 'api/CreditCheck/GetCustomerInformation/{creditCheckGuid}'
export const submitCreditCheck = 'api/CreditCheck/SubmitCreditCheck'



// WEBPACK FOOTER //
// ./src/constants/apiRoutes.ts